/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberSearchShowArticleResponse } from "./MemberSearchShowArticleResponse";

export type MemberSearchShowArticleResponseApiRespoonse = {
  data?: MemberSearchShowArticleResponse;
  status?: MemberSearchShowArticleResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberSearchShowArticleResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
